import 'css-chunk:src/shared/ErrorViewer.module.scss';export default {
  "wrapper": "_wrapper_8kvgh_1",
  "message": "_message_8kvgh_5"
};